<template>
  <div class="form-wrapper">
    <el-form :model="ruleform" class="popup" :rules="rules" ref="ruleform">
      <!-- <zj-layout-container class="header">
        <zj-layout-header>
          <div class="listtitle">
            景区监控
            <button
              type="button"
              aria-label="Close"
              class="el-dialog-close-btn"
              @click="onBack"
            >
              <i class="el-dialog__close el-icon el-icon-close"></i>
            </button>
          </div>
        </zj-layout-header>
      </zj-layout-container> -->
      <zj-layout-container class="content video-monitor">
        <div class="leftNav" v-if="!isShowAll">
          <div class="leftSpot"></div>
          <div class="tree-box">
            <div class="leftNav_title">
              实时视频
              <div class="title_btmLine"></div>
            </div>
            <el-input
              placeholder="搜索监控点"
              class="nav-tree-filter"
              v-model="filterText"
            ></el-input>
            <div class="nav-tree-content">
              <el-tree
                style="height:100%;"
                v-loading="loading"
                :element-loading-text="loadingText"
                @node-click="nodeClick"
                :data="nodes"
                node-key="id"
                :props="defaultProps"
                :filter-node-method="filterNode"
                class="zj-demo-player-tree-device-tree"
                ref="tree"
              ></el-tree>
            </div>
          </div>

          <div class="controlOneVideo" v-if="!isShowAll">
            <!-- <div class="leftSpot"></div> -->
            <div class="leftNav_title">
              云控制台
              <div class="title_btmLine"></div>
            </div>
            <div class="circleBox">
              <div id="wrap">
                <div
                  class="sector"
                  :style="{
                    transform: `rotate(${90 * index - 22.5}deg)`,
                  }"
                  v-for="(item, index) in myColor"
                  :key="index"
                >
                  <div
                    class="inner"
                    :id="`innder${index * 2}`"
                    @mousedown="chooseTriangle(index*2)"
                    @mouseup="mouseupButton(index*2)"
                  ></div>
                </div>
              </div>
            </div>
            <div style="margin-top: 3rem;">
              <div class="block">
                <span style="position:absolute; left:0;">焦距：</span>
                <el-button icon="el-icon-minus" round @click="zoomInVideo()"></el-button>
                <el-button icon="el-icon-plus" round @click="zoomOutVideo()"></el-button>
              </div>
            </div>
          </div>
        </div>
        <!-- 右侧内容 -->
        <div class="rightContent">
          <img v-show="isShowAll"  class="suoxiao" @click="changeQPing" src="../../../theme-default/src/images/suoxiao.png" />
          <div class="topContent" @dblclick="changeQPing">
            <!-- 分屏是一个的时候开始 -->
            <div class="oneVideoBox" v-if="showtype == '1'">
              <div class="showOneVideo">
                <div style="width:100%;height:100%;">
                  <div style="width:100%;height:100%;">
                    <videoItem ref="onePlayer"  :videoIndex="cameras[0].cameraId" :streamUrl="cameras[0].streamUrl" :item="cameras[0]"></videoItem>
                    <!-- <zj-camera-preview
                      ref="childOneVideo"
                      class="videoBig-item"
                      :cameraId="cameras[0].cameraId"
                      :cameraName="cameras[0].cameraName"
                      :autoplay="autoplay"
                      :streamType="streamType"
                    /> -->
                  </div>
                </div>
              </div>
            </div>
            <!-- 分屏是一个的时候结束 -->
            <!-- 分屏是3个 -->
            <div class="threes" v-if="showtype == '3'">
              <div class="leftBigVideo">
                <videoItem :videoIndex="cameras[0].cameraId" :streamUrl="cameras[0].streamUrl" :item="cameras[0]"></videoItem>
                <!-- <zj-camera-preview
                  class="videoBig-item"
                  :cameraId="cameras[0].cameraId"
                  :cameraName="cameras[0].cameraName"
                  :autoplay="autoplay"
                  :streamType="streamType"
                /> -->
              </div>
              <div class="rightVideo">
                <div class="rightbottomvideo">
                  <videoItem :videoIndex="cameras[1].cameraId" :streamUrl="cameras[1].streamUrl" :item="cameras[1]"></videoItem>
                  <!-- <zj-camera-preview
                    class="videoBig-item"
                    :cameraId="cameras[1].cameraId"
                    :cameraName="cameras[1].cameraName"
                    :autoplay="autoplay"
                    :streamType="streamType"
                  /> -->
                </div>
                <div class="rightbottomvideo">
                  <videoItem  :videoIndex="cameras[2].cameraId" :streamUrl="cameras[2].streamUrl" :item="cameras[2]"></videoItem>
                  <!-- <zj-camera-preview
                    class="videoBig-item"
                    :cameraId="cameras[2].cameraId"
                    :cameraName="cameras[2].cameraName"
                    :autoplay="autoplay"
                    :streamType="streamType"
                  /> -->
                </div>
              </div>
            </div>
            <!-- 分屏是3个结束 -->
            <!-- 分屏是4个，第一种开始 &&showtypeIndex=='2'-->
            <div
              class="threes averaBox"
              v-if="showtype == '4' && showtypeIndex == '2'"
            >
            
              <template v-for="(item, index) in cameras">
                <div
                  class="righttopvideo"
                  :key="index"
                  :class="{ martop12: index > 1 }"
                  @mouseover="mouseOver(index)"
                  @mouseleave="mouseLeave(index)"
                >
                  <!-- <div
                    class="closebtn"
                    @click="closeNowVideo(index)"
                    v-show="item.showClose"
                  ></div> -->
                  <videoItem  :videoIndex="item.cameraId" :streamUrl="item.streamUrl" :item="item"></videoItem>
                  <!-- <zj-camera-preview
                    class="videoBig-item"
                    :cameraId="item.cameraId"
                    :cameraName="item.cameraName"
                    :autoplay="autoplay"
                    :streamType="streamType"
                  /> -->
                </div>
              </template>
            </div>
            <!-- 分屏是4个，第一种结束 -->
            <!-- 分屏是4个，第二种开始 -->
            <div class="threes" v-if="showtype == '4' && showtypeIndex == '3'">
              <div class="leftBigVideo">
                <videoItem  :videoIndex="cameras[0].cameraId" :streamUrl="cameras[0].streamUrl" :item="cameras[0]"></videoItem>
                <!-- <zj-camera-preview
                  class="videoBig-item"
                  :cameraId="cameras[0].cameraId"
                  :cameraName="cameras[0].cameraName"
                  :autoplay="autoplay"
                  :streamType="streamType"
                /> -->
              </div>
              <div class="rightVideo">
                <div class="rightvideo3">
                  <videoItem  :videoIndex="cameras[1].cameraId" :streamUrl="cameras[1].streamUrl" :item="cameras[1]"></videoItem>
                  <!-- <zj-camera-preview
                    class="videoBig-item"
                    :cameraId="cameras[1].cameraId"
                    :cameraName="cameras[1].cameraName"
                    :autoplay="autoplay"
                    :streamType="streamType"
                  /> -->
                </div>
                <div
                  class="rightvideo3"
                  style="margin-top:1rem;margin-bottom:1rem;"
                >
                <videoItem  :videoIndex="cameras[2].cameraId" :streamUrl="cameras[2].streamUrl" :item="cameras[2]"></videoItem>
                  <!-- <zj-camera-preview
                    class="videoBig-item"
                    :cameraId="cameras[2].cameraId"
                    :cameraName="cameras[2].cameraName"
                    :autoplay="autoplay"
                    :streamType="streamType"
                  /> -->
                </div>
                <div class="rightvideo3">
                  <videoItem  :videoIndex="cameras[3].cameraId" :streamUrl="cameras[3].streamUrl" :item="cameras[3]"></videoItem>
                  <!-- <zj-camera-preview
                    class="videoBig-item"
                    :cameraId="cameras[3].cameraId"
                    :cameraName="cameras[3].cameraName"
                    :autoplay="autoplay"
                    :streamType="streamType"
                  /> -->
                </div>
              </div>
            </div>
            <!-- 分屏是4个，第二种结束 -->
            <!-- 分屏是6个，第1种开始 -->
            <div
              class="threes averaBox"
              v-if="showtype == '6' && showtypeIndex == '4'"
            >
              <div
                class="videoSix"
                v-for="(item, index) in cameras"
                :key="index"
              >
              <videoItem  :videoIndex="item.cameraId" :streamUrl="item.streamUrl" :item="item"></videoItem>
                <!-- <zj-camera-preview
                  class="videoBig-item"
                  :cameraId="item.cameraId"
                  :cameraName="item.cameraName"
                  :autoplay="autoplay"
                  :streamType="streamType"
                /> -->
              </div>
            </div>
            <!-- 分屏是6个，第1种结束 -->
            <!-- 分屏是6个，第2种开始 -->
            <div
              class="threes averaBox"
              v-if="showtype == '6' && showtypeIndex == '5'"
            >
              <div
                class="videoSixtop"
                :class="{ videoSixtop: index < 2, videoSixbottom: index > 1 }"
                v-for="(item, index) in cameras"
                :key="index"
              >
                <videoItem  :videoIndex="item.cameraId" :streamUrl="item.streamUrl" :item="item"></videoItem>
                <!-- <zj-camera-preview
                  class="videoBig-item"
                  :cameraId="item.cameraId"
                  :cameraName="item.cameraName"
                  :autoplay="autoplay"
                  :streamType="streamType"
                /> -->
              </div>
            </div>
            <!-- 分屏是6个，第二种结束 -->
            <!-- 分屏是7个 -->
            <div class="threes averaBox" v-if="showtype == '7'">
              <div class="leftBigVideo">
                <videoItem  :videoIndex="cameras[0].cameraId" :streamUrl="cameras[0].streamUrl" :item="cameras[0]"></videoItem>
                <!-- <zj-camera-preview
                  class="videoBig-item"
                  :cameraId="cameras[0].cameraId"
                  :cameraName="cameras[0].cameraName"
                  :autoplay="autoplay"
                  :streamType="streamType"
                /> -->
              </div>
              <div class="rightVideo averaBox">
                <template v-for="(item, index) in cameras">
                  <div class="rightvideo7" v-if="index != 0" :key="index">
                    <videoItem  :videoIndex="item.cameraId" :streamUrl="item.streamUrl" :item="item"></videoItem>
                    <!-- <zj-camera-preview
                      class="videoBig-item"
                      :cameraId="item.cameraId"
                      :cameraName="item.cameraName"
                      :autoplay="autoplay"
                      :streamType="streamType"
                    /> -->
                  </div>
                </template>
              </div>
            </div>
            <!-- 分屏是7个结束 -->
            <!-- 分屏是9个 第一种开始 &&showtypeIndex=='7'-->
            <div
              class="threes averaBox"
              v-if="showtype == '9' && showtypeIndex == '7'"
            >
              <template v-for="(item, index) in cameras">
                <div
                  class="rightvideo9"
                  :key="index"
                  @mouseover="mouseOver(index)"
                  @mouseleave="mouseLeave(index)"
                >
                <videoItem  :videoIndex="item.cameraId" :streamUrl="item.streamUrl" :item="item"></videoItem>
                  <!-- <div
                    class="closebtn"
                    @click="closeNowVideo(index)"
                    v-show="item.showClose"
                  ></div>
                  <zj-camera-preview
                    class="videoBig-item"
                    :cameraId="item.cameraId"
                    :cameraName="item.cameraName"
                    :autoplay="autoplay"
                    :streamType="streamType"
                  /> -->
                </div>
              </template>
            </div>
            <!-- 分屏是9个 第一种结束-->
            <!-- 分屏是9个，第2种开始 -->
            <div
              class="threes averaBox"
              v-if="showtype == '9' && showtypeIndex == '8'"
            >
              <div
                class="leftBigVideo"
                style="border:none !important;display:flex;flex-wrap:wrap;justify-content: space-between;"
              >
                <div
                  class="videoSixtop"
                  :class="{
                    videoNinetop: index == 0,
                    videoNinebottom: index == 1 || index == 2,
                  }"
                  v-for="(item, index) in cameras"
                  :key="index"
                >
                  <videoItem  :videoIndex="item.cameraId" :streamUrl="item.streamUrl" :item="item"></videoItem>
                  <!-- <zj-camera-preview
                    class="videoBig-item"
                    :cameraId="item.cameraId"
                    :cameraName="item.cameraName"
                    :autoplay="autoplay"
                    :streamType="streamType"
                  /> -->
                </div>
              </div>
              <div class="rightVideo averaBox">
                <template v-for="(item, index) in cameras">
                  <div class="rightvideo7" v-if="index > 2" :key="index">
                    <videoItem  :videoIndex="item.cameraId" :streamUrl="item.streamUrl" :item="item"></videoItem>
                    <!-- <zj-camera-preview
                      class="videoBig-item"
                      :cameraId="item.cameraId"
                      :cameraName="item.cameraName"
                      :autoplay="autoplay"
                      :streamType="streamType"
                    /> -->
                  </div>
                </template>
              </div>
            </div>
            <!-- 分屏是9个，第二种结束 -->
            <!-- 分屏是12个 第一种开始-->
            <div
              class="threes averaBox"
              v-if="showtype == '12' && showtypeIndex == '9'"
            >
              <template v-for="(item, index) in cameras">
                <div
                  class="rightvideo12"
                  :key="index"
                  :class="{ martop12: index > 3 }"
                >
                  <videoItem  :videoIndex="item.cameraId" :streamUrl="item.streamUrl" :item="item"></videoItem>
                  <!-- <zj-camera-preview
                    class="videoBig-item"
                    :cameraId="item.cameraId"
                    :cameraName="item.cameraName"
                    :autoplay="autoplay"
                    :streamType="streamType"
                  /> -->
                </div>
              </template>
            </div>
            <!-- 分屏是12个 第一种结束-->
            <!-- 分屏是12个 第二种开始-->
            <div
              class="threes averaBox"
              v-if="showtype == '12' && showtypeIndex == '10'"
            >
              <template v-for="(item, index) in cameras">
                <div
                  class="rightvideo12"
                  :key="index"
                  :class="{ martop12: index > 3 }"
                >
                  <videoItem  :videoIndex="item.cameraId" :streamUrl="item.streamUrl" :item="item"></videoItem>
                  <!-- <zj-camera-preview
                    class="videoBig-item"
                    :cameraId="item.cameraId"
                    :cameraName="item.cameraName"
                    :autoplay="autoplay"
                    :streamType="streamType"
                  /> -->
                </div>
              </template>
            </div>
            <!-- 分屏是12个 第二种结束-->
            <!-- 分屏是15个 第1种开始-->
            <div
              class="threes averaBox"
              v-if="showtype == '15' && showtypeIndex == '11'"
            >
              <template v-for="(item, index) in cameras">
                <div
                  class="rightvideo15"
                  :key="index"
                  :class="{ martop12: index > 4 }"
                >
                  <zj-camera-preview
                    class="videoBig-item"
                    :cameraId="item.cameraId"
                    :cameraName="item.cameraName"
                    :autoplay="autoplay"
                    :streamType="streamType"
                  />
                </div>
              </template>
            </div>
            <!-- 分屏是15个 第1种结束-->
            <!-- 分屏是15个 第2种开始-->
            <div
              class="threes averaBox"
              v-if="showtype == '15' && showtypeIndex == '12'"
            >
              <template v-for="(item, index) in cameras">
                <div class="rightvideo9" :key="index" v-if="index < 3">
                  <zj-camera-preview
                    class="videoBig-item"
                    :cameraId="item.cameraId"
                    :cameraName="item.cameraName"
                    :autoplay="autoplay"
                    :streamType="streamType"
                  />
                </div>
                <div
                  class="rightvideomini"
                  :key="index"
                  :class="{ martop12: index > 2 }"
                  v-if="index > 2"
                >
                  <zj-camera-preview
                    class="videoBig-item"
                    :cameraId="item.cameraId"
                    :cameraName="item.cameraName"
                    :autoplay="autoplay"
                    :streamType="streamType"
                  />
                </div>
              </template>
            </div>
            <!-- 分屏是15个 第2种结束-->
            <!-- 分屏是16个 第1种开始-->
            <div class="threes averaBox" v-if="showtype == '16'">
              <template v-for="(item, index) in cameras">
                <!-- :class="{'martop12':index>3}" -->
                <div class="rightvideo16" :key="index">
                  <zj-camera-preview
                    class="videoBig-item"
                    :cameraId="item.cameraId"
                    :cameraName="item.cameraName"
                    :autoplay="autoplay"
                    :streamType="streamType"
                  />
                </div>
              </template>
            </div>
            <!-- 分屏是16个 第1种结束-->
            <!-- 分屏是24个 第1种开始-->
            <div class="threes averaBox" v-if="showtype == '24'">
              <template v-for="(item, index) in cameras">
                <div class="rightvideo24" :key="index">
                  <zj-camera-preview
                    class="videoBig-item"
                    :cameraId="item.cameraId"
                    :cameraName="item.cameraName"
                    :autoplay="autoplay"
                    :streamType="streamType"
                  />
                </div>
              </template>
            </div>
            <!-- 分屏是24个 第1种结束-->
          </div>
          <div class="bottomContent" v-if="!isShowAll">
            <!-- 左侧单个视频控制播放 -->
            <div class="changebofang" v-if="cameras.length == 1">
              <div style="width:1.9rem;height:2.1rem;" @click="startOneVideo">
                <img
                  style="width:100%;height:100%;"
                  src="../../../theme-default/src/images/zanting.png"
                  alt=""
                />
              </div>
              <div class="line"></div>
              <div style="width:2.1rem;height:2.1rem;" @click="stopOneVideo">
                <img
                  style="width:100%;height:100%;"
                  src="../../../theme-default/src/images/tingzhi.png"
                  alt=""
                />
              </div>
            </div>
            <!-- 右侧分屏数量  v-if="cameras.length == 1"-->
            <div class="rightChange">
              <!-- <div @click="changeQPing()" style="margin-right:20px;">全屏按钮</div> -->
              <div class="changeLogo" @click="changeFenqi"></div>
              <div class="line"></div>
              <div style="width:3.1rem;height:2.2rem;" @click="dbOneVideo">
                <img
                  style="width:100%;height:100%;"
                  src="../../../theme-default/src/images/fangda.png"
                  alt=""
                />
              </div>
            </div>

            <ul class="fenpingBox" v-show="showFenqi">
              <li
                class="fenping_one"
                v-for="(item, index) in fenping"
                :key="index"
                @click="changeShowType(item.type, index)"
              >
                <img :src="item.src" alt="" />
                <div style="color:#bce1ee;font-size:1.4rem;text-align:center;">
                  {{ item.type }}
                </div>
              </li>
            </ul>
          </div>
        </div>
      </zj-layout-container>
    </el-form>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import ZJApp from "../../../../../app";
const ZJPlayer = ZJApp.ZJPlayer;
const MediaCenter = ZJPlayer.MediaCenter;
const MSG = ZJPlayer.MediaCenterMsg;
// const PageSize = 100;
// eslint-disable-next-line no-unused-vars
import MyApis from "../../../apis";
// import VideoMonitorControl from "../../../Components/Component-VideoMonitorControl";
// import VideoMonitorThree from "../../../Components/Component-VideoThree";
import src1 from "../../../theme-default/src/images/1.png";
import src2 from "../../../theme-default/src/images/2.png";
import src3 from "../../../theme-default/src/images/3.png";
import src4 from "../../../theme-default/src/images/4.png";
import src5 from "../../../theme-default/src/images/5.png";
import src6 from "../../../theme-default/src/images/6.png";
import src7 from "../../../theme-default/src/images/7.png";
import src8 from "../../../theme-default/src/images/8.png";
import src9 from "../../../theme-default/src/images/9.png";
// import src10 from "../../../theme-default/src/images/10.png";
// import src11 from "../../../theme-default/src/images/11.png";
// import src12 from "../../../theme-default/src/images/12.png";
// import src13 from "../../../theme-default/src/images/13.png";
// import src14 from "../../../theme-default/src/images/14.png";
// import src15 from "../../../theme-default/src/images/15.png";
// eslint-disable-next-line no-unused-vars
import $ from "jquery";
import videoItem from "../../../Components/hlsPlayer.vue";
import dataServerApi from "../../../../../../request/dataServerApi";
export default {
  name: "realTimeVideo",
  controller: "UI",
  action: "RealTimeVideo",
  components: {
    // VideoMonitorControl
    videoItem
  },
  data() {
    return {
      fenping: [
        { type: "1", src: src1 },
        { type: "3", src: src2 },
        { type: "4", src: src3 },
        { type: "4", src: src4 },
        { type: "6", src: src5 },
        { type: "6", src: src6 },
        { type: "7", src: src7 },
        { type: "9", src: src8 },
        { type: "9", src: src9 },
        // {"type":"12","src":src10},
        // {"type":"12","src":src11},
        // {"type":"15","src":src12},
        // {"type":"15","src":src13},
        // {"type":"16","src":src14},
        // {"type":"24","src":src15}
      ],
      isStart: true,
      valueJj: 20,
      valueCircle: 20,
      showFenqi: false,
      filterText: "",
      loading: false,
      loadingText: "",
      nodes: [],
      autoplay: true,
      defaultProps: {
        children: "children",
        label: "label",
      },
      previewPlayerConfigs: {
        streamType: 1, //0 - 主码流；1 - 子码流
        autoplay: false,
      },
      playbackPlayerConfigs: {
        streamType: 1, //0 - 主码流；1 - 子码流
        autoplay: false,
      },
      cameras: [
        {
          cameraId: "",
          cameraName: "",
          showClose: false,
          streamUrl:"",
          fatherCameraName:""
        },
      ],
      selectPlayerIndex: 0,
      color: ["2ac1ff", "2ac1ff", "#2ac1ff", "2ac1ff", "2ac1ff", "2ac1ff"],
      myColor: ["2ac1ff", "2ac1ff", "#2ac1ff", "2ac1ff"],
      mc: "",
      Triangle: "",
      showtype: "4", //摆放几个视频
      showtypeIndex: 2,
      isShowAll: false,
      treeClickCount: 0,
      viewMode:"static",
      currentIndex:"0",
      indexCode:""
    };
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
    // 监听路由参数变化，当参数改变时重新处理
    $route(to, from) {
      // 如果路由参数中的name变化了
      if (to.query.name !== from.query.name) {
        const p = to.query.name;
        if (p) {
          this.search(() => {
            // 使用Tree组件内置的filter方法过滤节点
            this.filterText = p;
            
            // 直接在原始数据上筛选，利用filterNode的逻辑
            if (this.nodes && this.nodes.length > 0) {
              // 遍历区域（第一层）
              for (const region of this.nodes) {
                // 检查区域是否匹配
                if (this.filterNode(p, region)) {
                  console.log("触发区域双击=====");
                }
                
                // 遍历设备（第二层）
                if (region.children && region.children.length > 0) {
                  for (const device of region.children) {
                    // 使用相同的filterNode逻辑筛选设备
                    if (this.filterNode(p, device)) {
                      console.log("触发设备双击=====");
                      let showtype = Number(this.showtype);
                      
                      // 直接加载视频
                      if (this.cameras && this.cameras[this.selectPlayerIndex]) {
                        this.cameras[this.selectPlayerIndex].cameraId = device.id;
                        this.cameras[this.selectPlayerIndex].cameraName = device.label;
                        this.cameras[this.selectPlayerIndex].fatherCameraName = region.label;
                        this.getStreamUrlByCode(device.id, this.selectPlayerIndex);
                        this.selectPlayerIndex = (this.selectPlayerIndex + 1) % showtype;
                      }
                    }
                  }
                }
              }
            }
          });
        }
      }
    }
  },
  created() {
    this.changeShowType(this.showtype, this.showtypeIndex);
    const p = this.$route.query.name;
    // 如果有query参数，添加回调处理
    if (p) {
      this.search(() => {
        // 使用Tree组件内置的filter方法过滤节点
        this.filterText = p;
        
        // 直接在原始数据上筛选，利用filterNode的逻辑
        if (this.nodes && this.nodes.length > 0) {
          // 遍历区域（第一层）
          for (const region of this.nodes) {
            // 检查区域是否匹配
            if (this.filterNode(p, region)) {
              console.log("触发区域双击=====");
            }
            
            // 遍历设备（第二层）
            if (region.children && region.children.length > 0) {
              for (const device of region.children) {
                // 使用相同的filterNode逻辑筛选设备
                if (this.filterNode(p, device)) {
                  console.log("触发设备双击=====");
                  let showtype = Number(this.showtype);
                  
                  // 直接加载视频
                  if (this.cameras && this.cameras[this.selectPlayerIndex]) {
                    this.cameras[this.selectPlayerIndex].cameraId = device.id;
                    this.cameras[this.selectPlayerIndex].cameraName = device.label;
                    this.cameras[this.selectPlayerIndex].fatherCameraName = region.label;
                    this.getStreamUrlByCode(device.id, this.selectPlayerIndex);
                    this.selectPlayerIndex = (this.selectPlayerIndex + 1) % showtype;
                  }
                }
              }
            }
          }
        }
      });
    } else {
      // 没有query参数，直接调用search
      this.search();
    }
  },
  mounted() {
    const p = this.$route.query.name;
    console.log("收到参数：",p);
    this.$store.dispatch("submitIsShowbg", false);
    this.theme.sidemenu.visiable = false;
    this.mc = new MediaCenter();
    this.mc.on("connected", () => this.onConnected());
    this.mc.on("msg", (e) => this.onRecv(e));
    this.mc.on("error", (e) => this.onError(e));
    // this.handleLoad();
    this.logInfo.ActionName = "实时监控查询";
    this.logInfo.LogMessage = "实时监控查询";
    this.logInfo.ModuleName = "视频监控";
    this.logInfo.PageName = "实时监控页面";
    this.addOperationLog();
    // this.theme.header.visiable = false
    // this.theme.sidemenu.visiable = false
  },
  methods: {
    ...mapActions(["submitIsShowbg"]),
    dbOneVideo() {
      if (this.showtype == 1) {
        // 全屏
        this.$refs.childOneVideo.onDblClick();
      } else {
        this.changeQPing();
      }
    },
    changeQPing() {
      this.isShowAll = !this.isShowAll;
      if (this.isShowAll) {
        this.theme.header.visiable = false;
        this.theme.sidemenu.visiable = false;
      } else {
        this.theme.header.visiable = true;
        this.theme.sidemenu.visiable = true;
      }
    },
    closeNowVideo(index) {
      this.cameras[index].cameraId = "";
      this.cameras[index].cameraName = "";
      // console.log(index)
      // console.log(this.cameras)
      //  if(this.selectPlayerIndex>index){
      this.selectPlayerIndex = index;
      //  }
    },
    mouseOver(index) {
      this.cameras[index].showClose = true;
    },
    // 移出
    mouseLeave(index) {
      this.cameras[index].showClose = false;
    },
    startOneVideo() {
      // 开始播放视频
      // this.$refs.childOneVideo.play();
      this.$refs.onePlayer.startPlay();
    },
    stopOneVideo() {
      // 停止播放视频
      // this.$refs.childOneVideo.stop();
      this.$refs.onePlayer.pausePlay();
    },
    changeShowType(type, index) {
      // 改变视频显示个数
      this.showtype = type;
      this.showtypeIndex = index;
      let showtype = Number(this.showtype);
      console.log("showtype");
      console.log(showtype, index);
      let length = this.cameras.length;
      if (length <= showtype) {
        let num = showtype - length;
        for (let i = 0; i < num; i++) {
          let obj = {
            cameraId: "",
            cameraName: "",
            fatherCameraName: "",
            showClose: false,
            streamUrl:""
          };
          this.cameras.push(obj);
        }
      } else {
        this.cameras.splice(showtype);
      }
      console.log("this.cameras");
      console.log(this.cameras);
      this.showFenqi = false;
    },
    changeTopSlider(e) {
      console.log(e);
      if (e > this.oldValueJj) {
        this.Triangle = "ZOOM_IN";
        this.moveCamera(0);
        setTimeout(() => {
          this.moveCamera(1);
        }, 10);
      } else {
        this.Triangle = "ZOOM_OUT";
        this.moveCamera(0);
        setTimeout(() => {
          this.moveCamera(1);
        }, 10);
      }
      this.oldValueJj = e;
    },
    zoomInVideo() {
      this.Triangle = "ZOOM_OUT";
      this.moveCamera(0);
      setTimeout(() => {
        this.moveCamera(1);
      }, 10);
    },
    zoomOutVideo() {
      this.Triangle = "ZOOM_IN";
      this.moveCamera(0);
      setTimeout(() => {
        this.moveCamera(1);
      }, 10);
    },
    changeSlider(e) {
      console.log(e);
      this.Triangle = "IRIS_ENLARGE";
      this.moveCamera(0);
    },
    // 鼠标按下
    chooseTriangle(index) {
      let id = `#innder${index}`;
      // eslint-disable-next-lineno-undef
      $("#wrap")
        .find(".innerSelector")
        .addClass("inner")
        .removeClass("innerSelector");
      $(id)
        .removeClass("inner")
        .addClass("innerSelector");
      if (index == 0) {
        this.Triangle = "UP";
      } else if (index == 2) {
        this.Triangle = "RIGHT";
      } else if (index == 4) {
        this.Triangle = "DOWN";
      } else if (index == 6) {
        this.Triangle = "LEFT";
      }
      this.moveCamera(0); 
    },
    //鼠标抬起
    mouseupButton(index) {
      let id = `#innder${index}`;
      // eslint-disable-next-lineno-undef
      $("#wrap")
        .find(".innerSelector")
        .addClass("innerSelector")
        .removeClass("inner");
      $(id)
        .removeClass("innerSelector")
        .addClass("inner");
      this.moveCamera(1);
    },
    search(callback) {
      let that = this;
      new MyApis.EquipmentApi()
        .GetRegionEquipment({
          EquipmentType: "Monitor",
        })
        .then((r) => {
          r = r.data.Data;
          // console.log(r);
          this.nodes = that.convertToTreeNodesfunction(r);
          // console.log("this.nodes");
          // console.log(this.nodes);
          
          // 如果有回调函数，在数据加载完成后执行
          if (typeof callback === 'function') {
            this.$nextTick(() => {
              callback();
            });
          }
        })
        .catch((e) => {
          console.error(e);
          that.$message({
            message: e.RspMsg ? e.RspMsg : "搜索视频失败！",
            type: "error",
          });
        });
    },
    convertToTreeNodesfunction(list) {
      let result = [];
      for (let i = 0; i < list.length; i++) {
        var regionData = list[i];
        var region = {
          id: regionData.RegionId,
          label: regionData.RegionName,
          children: [],
        };

        if (!regionData.Devices) continue;
        for (let j = 0; j < regionData.Devices.length; j++) {
          var deviceData = regionData.Devices[j];
          region.children.push({
            id: deviceData.DeviceId,
            label: deviceData.DeviceName,
            children: [],
          });
        }
        result.push(region);
      }
      // console.log("result")
      // console.log(result)
      return result;
    },
    nodeoneClick(data, node) {
      if (node.level == 2) {
        if (this.cameras && this.cameras[0]) {
          this.cameras[0].cameraId = data.id;
          this.cameras[0].cameraName = data.label;
        }
      }
    },
    // eslint-disable-next-line no-unused-vars
    nodeClick: function(data, node, self) {
      console.log(data)
      console.log("node")
      console.log(node)
      //记录点击次数
      this.treeClickCount++;
      //单次点击次数超过2次不作处理,直接返回,也可以拓展成多击事件
      if (this.treeClickCount >= 2) {
        return;
      }
      //计时器,计算300毫秒为单位,可自行修改
      this.timer = window.setTimeout(() => {
        if (this.treeClickCount == 1) {
          //把次数归零
          this.treeClickCount = 0;
          //单击事件处理
        } else if (this.treeClickCount > 1) {
          //把次数归零
          this.treeClickCount = 0;
          let showtype = Number(this.showtype);
          console.log(this.selectPlayerIndex)
          if (node.level == 2) {
            if (this.cameras && this.cameras[this.selectPlayerIndex]) {
              this.cameras[this.selectPlayerIndex].cameraId = data.id;
              this.cameras[this.selectPlayerIndex].cameraName = data.label;
              this.cameras[this.selectPlayerIndex].fatherCameraName = node.parent.data.label;
              this.getStreamUrlByCode(data.id,this.selectPlayerIndex);
              this.selectPlayerIndex = (this.selectPlayerIndex + 1) % showtype;
              console.log( this.cameras)
            }
          }
        }
      }, 300);
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    getStreamUrlByCode(code,index) {
      let params= {"indexCode":code}
      // let params= {"indexCode":"865ac4e15d0947d7bec6349ddf380f2d"}
      dataServerApi.getstreamurl(params).then(res=>{
        console.log(res)
        if(res.code==0){
          let streamUrl = res.data.data.url;
          this.cameras[index].streamUrl =streamUrl;
          console.log("streamUrl")
          console.log(streamUrl)
          console.log(this.cameras)
          // return streamUrl;
          // this.createFlv(streamUrl);
          // if (this.cameras && this.cameras[this.selectPlayerIndex]) {
          //     this.cameras[this.selectPlayerIndex].cameraId = data.id;
          //     this.cameras[this.selectPlayerIndex].cameraName = data.label;

          //     this.selectPlayerIndex = (this.selectPlayerIndex + 1) % showtype;
          //   }
        }
      })
    },
    onBack: function() {
      this.$emit("handlerclose");
    },
    changeFenqi() {
      this.showFenqi = !this.showFenqi;
    },
    // 成功连接到媒体中心
    onConnected() {
      console.log("链接成功");
    },
    // 接收到媒体中心的响应
    onRecv(e) {
      console.log("回应");
      console.log(e);
    },
    moveCamera(action) {  //0:开始动、1：结束动
      if (this.Triangle == "") {
        this.$message({
          type: "alert",
          message: "没有选择摄像机移动方向",
        });
        return;
      }

      var PTZCmds = {
        UP: 21, // 上转
        DOWN: 22, // 下转
        LEFT: 23, // 左转
        RIGHT: 24, // 右转
        LEFT_UP: 25, // 左上
        LEFT_DOWN: 27, // 左下
        RIGHT_UP: 26, // 右上
        RIGHT_DOWN: 28, // 右下
        ZOOM_IN: 13, // 焦距变大
        ZOOM_OUT: 14, // 焦距变小
        FOCUS_NEAR: 11, // 焦点前移
        FOCUS_FAR: 12, // 焦点后移
        IRIS_ENLARGE: 15, // 光圈扩大
        IRIS_REDUCE: 16, // 光圈缩小
        GOTO_PRESET: 39, // 跳转到预置点 （param 需设置为预置点的 ID）
      };
      let id = this.cameras[0].cameraId;
      let command = this.Triangle;
      let params = {
        cameraId: id, //摄像机 ID
        command: PTZCmds[command], //云台命令，参考 PTZCmds 的定义
        action: action, //启动/停止：0 - 启动, 1 - 停止
        speed: 50, //云台速度, 取值范围为1-100
        param: 0, //控制参数, 目前，仅 PTZCmds.GOTO_PRESET 命令需要此参数
      };
      // console.log("params");
      // console.log(params);
      if (this.mc.$connected) {
        //TODO: 直接下发控制指令
        // this.mc.sendCmd(MSG.PTZ_CONTROL, params);
        setTimeout(() => {
          this.mc.sendCmd(MSG.PTZ_CONTROL, params);
        },10);
      } else {
        this.mc.connect().then(() => {
          //TODO: 下发控制指令
          // this.mc.sendCmd(MSG.PTZ_CONTROL, params);
          setTimeout(() => {
            this.mc.sendCmd(MSG.PTZ_CONTROL, params);
          },10);
        });
      }
    },
  },
  beforeDestroy() {
    this.theme.sidemenu.visiable = true;
    this.$store.dispatch("submitIsShowbg", true);
  },
};
</script>
<style scoped>
.leftNav {
  border: 0.1rem solid #00bcfe;
  padding: 2.8rem 3rem;
  position: relative;
  background: #003669;
  width: 20%;
  display: flex;
  flex-direction: column;
  margin-right: 1.5rem;
  box-sizing: border-box;
  /*  overflow: scroll; */
}
.leftSpot {
  width: 22.2rem;
  height: 12.5rem;
  background: url("../../../theme-default/src/images/guangxiao.png") no-repeat;
  background-size: cover;
  position: absolute;
  left: -3.5rem;
  top: -6.3rem;
}
.tree-box {
  height: auto;
  flex: 1;
  overflow: hidden;
}
.leftNav_title {
  font-size: 2.2rem;
  font-weight: bold;
  border-bottom: 0.1rem solid #0ec0fe;
  color: #00bcfe;
  height: 4rem;
  position: relative;
}
.nav-tree-filter {
  border-radius: 0.6rem;
  border: solid 0.1rem #00bcfe;
  margin-top: 2.5rem;
  margin-bottom: 2rem;
}
.nav-tree-content {
  height: 27rem;
  overflow-y: auto;
}
.title_btmLine {
  width: 4.7rem;
  height: 0.7rem;
  background-color: #28bbff;
  position: absolute;
  bottom: -0.35rem;
  left: 1.7rem;
}
.rightContent {
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}
.rightContent .suoxiao{
  position: absolute;
  right: 10px;
  bottom: 10px;
  z-index: 2;
}
.topContent {
  flex: 1;
  overflow: hidden;
  width: 100%;
}
.bottomContent {
  width: 100%;
  height: 9.3rem;
  background-color: #003669;
  border-radius: 0.6rem;
  border: solid 0.1rem #00bcfe;
  margin-top: 2rem;
  position: relative;
}

/* 选择一个视频 */
.oneVideoBox {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  overflow: hidden;
}
/* 左侧展示视频 */
.showOneVideo {
  flex: 1;
  height: 100%;
  background-color: black;
  border: solid 0.1rem #00bcfe;
}
.controlOneVideo {
  /* width: 27%; */
  max-width: 336px;
  height: 28rem;
  background-color: #003669;
  /* border: solid 0.1rem #00bcfe; */
  position: relative;
  /* margin-left: 1.5rem; */
}
.videoOne {
  width: 100%;
  height: 100%;
}
.video-wrapper {
  width: 100%;
  height: 100%;
}

/* 滑块样式 */
.block {
  display: flex;
  align-items: center;
  justify-content: center;
}
.block > .el-button.is-round{
  padding: 5px 20px !important;
}
.zj_slider {
  width: 19rem;
}
/* 选择分屏的样式 */
.changeLogo {
  width: 3.1rem;
  height: 2.2rem;
  background: url("../../../theme-default/src/images/fenping.png") no-repeat;
  background-size: cover;
}
.fenpingBox {
  width: 20rem;
  background-color: #003669;
  border: solid 0.1rem #00bcfe;
  position: absolute;
  right: 1rem;
  bottom: 6rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 2rem;
  z-index: 10000;
}
.fenping_one {
  list-style: none;
  margin-right: 1rem;
}
.fenping_one img {
  width: 3.1rem;
  height: 2.4rem;
  margin-bottom: 0.8rem;
}
.martop2 {
  margin-top: 1.5rem;
}
/* 圆盘样式 */
.circleBox {
  width: 14.8rem;
  height: 14.8rem;
  border-radius: 50%;
  border: solid 0.2rem #00bcfe;
  margin: 0 auto;
  margin-top: 2rem;
  position: relative;
}

#wrap {
  width: 13rem;
  height: 13rem;
  position: absolute;
  left: 0.7rem;
  top: 0.7rem;
}
.sector {
  width: 100%;
  height: 100%;
  position: absolute;
  clip: rect(0 13rem 6.5rem 6.5rem);
  overflow: hidden;
}
.inner,
.innerSelector {
  width: 100%;
  height: 100%;
  position: absolute;
  clip: rect(0 6.5rem 13rem 0);
  transform: rotate(45deg);
  text-align: left;
  border-radius: 50%;
  /* z-index: 1000; */
}
.inner::before {
  content: "";
  position: absolute;
  top: 0.4rem;
  width: 5.4rem;
  height: 3.3rem;
  right: 5.7rem;
  z-index: 99;
  background: url("../../../theme-default/src/images/shang.png");
  background-size: cover;
  transform: rotate(-23deg);
}
.innerf {
  width: 100%;
  height: 100%;
  position: absolute;
  clip: rect(0 6.5rem 13rem 0);
  transform: rotate(90deg);
  text-align: left;
  border-radius: 50%;
  z-index: 1000;
}

.innerf::before {
  content: "";
  width: 5.4rem;
  height: 3.3rem;
  position: absolute;
  top: 0.4rem;
  right: 5.7rem;
  z-index: 99;
  background: url("../../../theme-default/src/images/shang.png");
  background-size: cover;
  transform: rotate(-23deg);
}
.innerSelector::before {
  content: "";
  position: absolute;
  width: 5.4rem;
  height: 3.3rem;
  top: 0.4rem;
  right: 5.7rem;
  z-index: 99;
  background: url("../../../theme-default/src/images/shang2.png");
  background-size: cover;
  transform: rotate(-23deg);
}
/* 小圆盘样式 */
.circleMini {
  width: 6rem;
  height: 6rem;
  border-radius: 50%;
  background-color: #116ea5;
  border: solid 0.1rem #00bcfe;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  justify-content: center;
}
.fangstop {
  width: 2rem;
  height: 2rem;
  border-radius: 0.3rem;
  background: #29c7ff;
}
.fangstart {
  width: 1.6rem;
  height: 2rem;
  background: url("../../../theme-default/src/images/start.png") no-repeat;
  background-size: cover;
}
/* 三个视频 */
.threes {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 100%;
}
.leftBigVideo {
  flex: 1;
  height: 100%;
  border: solid 0.1rem #00bcfe;
  margin-right: 2rem;
}
.leftVideo {
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.rightVideo {
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.righttopvideo {
  height: 49%;
  width: 49%;
  border: solid 0.1rem #00bcfe;
  position: relative;
}
.closebtn {
  width: 12px;
  height: 12px;
  position: absolute;
  right: 8px;
  top: 8px;
  background: url("../../../../../../assets/close.png") no-repeat;
  background-size: cover;
  z-index: 9999;
}
.rightbottomvideo {
  height: 49%;
  width: 100%;
  border: solid 0.1rem #00bcfe;
}
.videoBig-item {
  width: 100%;
  height: 100%;
}
.rightvideo3 {
  height: 32%;
  width: 100%;
  border: solid 0.1rem #00bcfe;
}
/* 6个平分的样式 */
.videoSix {
  width: 49%;
  height: 32%;
  border: solid 0.1rem #00bcfe;
}
.averaBox {
  flex-wrap: wrap;
}
.videoSixtop {
  width: 49%;
  height: 48%;
  border: solid 0.1rem #00bcfe;
}
.videoSixbottom {
  width: 23.5%;
  height: 49%;
  border: solid 0.1rem #00bcfe;
  margin-top: 1.5rem;
}
.rightvideo7 {
  width: 48%;
  height: 32%;
  border: solid 0.1rem #00bcfe;
}
.rightvideo9 {
  width: 32%;
  height: 32%;
  border: solid 0.1rem #00bcfe;
  position: relative;
}
.videoNinetop {
  width: 100%;
  height: 48%;
  border: solid 0.1rem #00bcfe;
}
.videoNinebottom {
  width: 49%;
  height: 49%;
  border: solid 0.1rem #00bcfe;
  margin-top: 1.5rem;
}
.rightvideo12 {
  width: 23%;
  height: 32%;
  border: solid 0.1rem #00bcfe;
}
.martop12 {
  margin-top: 1rem;
}
.rightvideo15 {
  width: 19%;
  height: 31%;
  border: solid 0.1rem #00bcfe;
}
.rightvideomini {
  width: 15.5%;
  height: 32%;
  border: solid 0.1rem #00bcfe;
}
.rightvideo16 {
  width: 24%;
  height: 24%;
  border: solid 0.1rem #00bcfe;
}
.rightvideo24 {
  width: 15.5%;
  height: 24%;
  border: solid 0.1rem #00bcfe;
}

.zj-demo-player-tree-device-tree .el-tree-node.is-current {
  background-color: rgba(7, 78, 133, 0.7);
}
.changebofang {
  display: flex;
  align-items: center;
  position: absolute;
  left: 3.9rem;
  top: 3.4rem;
}
.line {
  width: 0.2rem;
  height: 2.6rem;
  background: linear-gradient(90deg, #00bcfe 0%, #4ed1ff 100%);
  margin-left: 2.9rem;
  margin-right: 2.9rem;
  opacity: 0.4;
}
.rightChange {
  position: absolute;
  right: 3rem;
  top: 3.4rem;
  display: flex;
  align-items: center;
}
</style>
